import Vue from 'vue';
import Vuex from 'vuex';
import { cloneDeep } from 'lodash';
import axios from 'axios';

const api = axios.create({
  baseURL: (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`,
  headers: {
    'Content-Type': 'application/hal+json',
    Accept: 'application/json',
  },
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {
      objectName: '',
      objectAdress: '',
      userName: '',
      userMail: '',
      userPhone: '',
      userCompany: '',
      link: '',
    },
    result: {
      total: {},
      sectors: {},
    },
    minorResultBallast: [
      {
        name: 'C',
        recommended: 0,
        options: [
          {
            rollWidth: 1.05,
            thickness: 100,
          },
        ],
      },
      {
        name: 'D',
        recommended: 0,
        options: [
          {
            rollWidth: 2.05,
            thickness: 110,
          },
        ],
      },
      {
        name: 'E',
        recommended: 0,
        options: [
          {
            rollWidth: 3.05,
            thickness: 120,
          },
        ],
      },
    ],
    minorResult: [],
    /* eslint-disable import/no-unresolved */
    /* eslint-disable global-require */
    insulationMaterials: [],
    materials: [],
    mounting: [],
    categories: [],
    albums: [],
    fasteners: [],
    location: {
      zone: '',
      pressure: '',
      type: null,
      coefficient: 1.4,
    },
    sectors: [
      {
        base: {
          id: null,
          type: {
            id: null,
            isCustom: false,
            size: null,
          },
        },
        insulation: {
          isEnabled: true,
          data: {
            type: 'mechanical',
            thickness: 0,
          },
        },
        material: {
          mounting: 'mechanical',
          id: null,
          size: {
            C: '',
            D: '',
            E: '',
          },
        },
        height: 0,
        sideB: 8,
        sideL: 12,
        sectorsCount: 1,
        inAppStep: 'Base',
        sectorName: 'Участок 1',
        sectorImage: '',
      },
    ],
    defaultSector: {
      base: {
        id: null,
        type: {
          id: null,
          isCustom: false,
          size: null,
        },
      },
      insulation: {
        isEnabled: true,
        data: {
          type: 'mechanical',
          thickness: 0,
        },
      },
      material: {
        mounting: 'mechanical',
        id: null,
        size: {
          C: '',
          D: '',
          E: '',
        },
      },
      height: 0,
      sideB: 8,
      sideL: 12,
      sectorsCount: 1,
      inAppStep: 'Base',
      sectorName: '',
      sectorImage: '',
    },
    defaultSvgParams: {
      width: 700,
      height: 500,
      baseHeight: 4,
      baseWidth: 6,
      navScale: 0.1765,
    },
    defaultBaseType: {
      id: null,
      isCustom: false,
      size: null,
    },
    defaultInsulationData: {
      type: 'mechanical',
      thickness: 0,
    },
  },
  mutations: {
    UPDATE_LOCATION_PARAM(state, payload) {
      state.location[payload.param] = payload.val;
    },
    UPDATE_SECTOR_BASE(state, payload) {
      state.sectors[payload.id].base.id = payload.material;
      if (!payload.hasTypes) {
        delete state.sectors[payload.id].base.type;
      } else {
        Vue.set(state.sectors[payload.id].base, 'type', cloneDeep(state.defaultBaseType));
      }
    },
    UPDATE_SECTOR_BASE_TYPE(state, payload) {
      state.sectors[payload.id].base.type.id = payload.material;
      state.sectors[payload.id].base.type.size = payload.size;
    },
    UPDATE_SECTOR_BASE_TYPE_MOD(state, payload) {
      state.sectors[payload.id].base.type.id = null;
      if (payload.mod) {
        state.sectors[payload.id].base.type.isCustom = payload.mod;
      } else {
        state.sectors[payload.id].base.type.size = null;
      }
    },
    UPDATE_SECTOR_BASE_TYPE_SIZE(state, payload) {
      state.sectors[payload.id].base.type.size = payload.size;
    },
    UPDATE_INSULATION_NECESSITY(state, payload) {
      state.sectors[payload.id].insulation.isEnabled = payload.val;
      if (!payload.val) {
        delete state.sectors[payload.id].insulation.data;
      } else {
        Vue.set(state.sectors[payload.id].insulation, 'data', cloneDeep(state.defaultInsulationData));
      }
    },
    UPDATE_INSULATION_PARAM(state, payload) {
      state.sectors[payload.id].insulation.data[payload.param] = payload.val;
    },
    UPDATE_SECTOR_MATERIAL_MOUNTING(state, payload) {
      state.sectors[payload.id].material.mounting = payload.mounting;
      if (payload.mounting === 'mechanical') {
        delete state.sectors[payload.id].material.type;
      } else {
        Vue.set(state.sectors[payload.id].material, 'type', 'reinforced');
      }
    },
    UPDATE_SECTOR_MATERIAL_PARAM(state, payload) {
      state.sectors[payload.id].material[payload.param] = payload.val;
    },
    UPDATE_SECTOR_MATERIAL_SIZE_PARAM(state, payload) {
      // console.log(payload);
      state.sectors[payload.id].material.size[payload.param] = payload.val;
    },
    CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(state, payload) {
      state.sectors[payload].material.size.C = '';
      state.sectors[payload].material.size.D = '';
      state.sectors[payload].material.size.E = '';
    },
    CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS(state) {
      for (let i = 0; i < state.sectors.length; i += 1) {
        state.sectors[i].material.size.C = '';
        state.sectors[i].material.size.D = '';
        state.sectors[i].material.size.E = '';
      }
    },
    UPDATE_SECTOR_PARAM(state, payload) {
      state.sectors[payload.id][payload.param] = payload.val;
    },
    UPDATE_SECTOR_STEP(state, payload) {
      state.sectors[payload.id].inAppStep = payload.val;
    },
    DELETE_SECTOR: (state, payload) => {
      state.sectors.splice(payload, 1);
    },
    ADD_NEW_SECTOR: (state) => {
      state.defaultSector.sectorName = `Участок ${state.sectors.length + 1}`;
      state.sectors.push(cloneDeep(state.defaultSector));
    },
    UPDATE_STATE_ARRAY: (state, payload) => {
      Vue.set(state, [payload.param], cloneDeep(payload.array));
    },
    UPDATE_RESULT_ARRAY: (state, payload) => {
      // console.log(state.result[payload.param]);
      state.result[payload.param] = cloneDeep(payload.array);
      // console.log(state.result[payload.param]);
      // state.sectors[payload.param].push(cloneDeep(payload.array));
    },
    UPDATE_RESULT: (state, payload) => {
      state.result = payload;
    },
    UPDATE_STATE_OBJECT: (state, payload) => {
      state[payload.object] = payload.val;
    },
    UPDATE_USER_INFO_PARAM(state, payload) {
      state.userInfo[payload.param] = payload.val;
    },
    RESET_SECTORS(state) {
      state.sectors = [];
      state.userInfo.objectName = '';
      state.userInfo.objectAdress = '';
      state.userInfo.userName = '';
      state.userInfo.userMail = '';
      state.userInfo.userPhone = '';
      state.userInfo.userCompany = '';
      state.userInfo.link = '';
      state.location.zone = '';
      state.location.pressure = '';
      state.location.type = null;
      state.location.coefficient = 1.4;
      state.location.zone = '';
    },
  },
  getters: {
    getSector: state => id => state.sectors[id],
    getSectorResult: state => id => state.result.sectors[id],
  },
  actions: {
    async fetchData(ctx) {
      await api.get('service_api/content')
        .then((response) => {
          // console.log(response.data);
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'insulationMaterials', array: response.data.baseTypes });
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'materials', array: response.data.materials });
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'mounting', array: response.data.mounting });
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'categories', array: response.data.categories });
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'albums', array: response.data.albums });
          ctx.commit('UPDATE_STATE_ARRAY', { param: 'fasteners', array: response.data.fasteners });
        });
    },
  },
  modules: {},
});
